// src/utils/parseMarkdown.ts
import React from 'react';

// Inline markdown renderer: handles **bold**, `code`, and [link](url) only.
// Patterns are single-line — spans with embedded newlines will not match (intentional).
export function parseMarkdown(text: string): React.ReactNode {
  if (!text) return '';
  const parts: React.ReactNode[] = [];
  const regex = /\*\*(.+?)\*\*|`(.+?)`|\[(.+?)\]\((.+?)\)/g;
  let lastIndex = 0;
  let match: RegExpExecArray | null;

  while ((match = regex.exec(text)) !== null) {
    if (match.index > lastIndex) {
      parts.push(text.slice(lastIndex, match.index));
    }
    if (match[1] !== undefined) {
      parts.push(React.createElement('strong', { key: match.index }, match[1]));
    } else if (match[2] !== undefined) {
      parts.push(React.createElement('code', { key: match.index }, match[2]));
    } else {
      const href = /^https?:\/\//i.test(match[4]) ? match[4] : '#';
      parts.push(React.createElement('a', { key: match.index, href, target: '_blank', rel: 'noopener noreferrer' }, match[3]));
    }
    lastIndex = regex.lastIndex;
  }

  if (lastIndex < text.length) {
    parts.push(text.slice(lastIndex));
  }

  if (parts.length === 1) return parts[0];
  return React.createElement(React.Fragment, null, ...parts);
}
